"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TableDownstreamVirtualConnectionsQueryGrid = void 0;
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const catalog_messages_1 = require("@tableau/catalog-messages");
const catalog_queries_1 = require("@tableau/catalog-queries");
const data_catalog_shared_1 = require("@tableau/data-catalog-shared");
const VirtualConnectionRowDataFunctions_1 = require("../database/functions/VirtualConnectionRowDataFunctions");
const VirtualConnectionsDisplayGrid_1 = require("../sharedDisplayGrid/VirtualConnectionsDisplayGrid");
function selectConnectionListResult(resultData) {
    const table = resultData && resultData.tables && resultData.tables[0];
    return table.downstreamVirtualConnectionsConnection;
}
function selectConnectionListResultForFilteredQuery(resultData) {
    const table = resultData && resultData.tables && resultData.tables[0];
    const column = table && table.columns && table.columns[0];
    return column.downstreamVirtualConnectionsConnection;
}
function selectMaxCountsResult(resultData) {
    const table = resultData && resultData.tables && resultData.tables[0];
    return table;
}
function selectMaxCountsResultForFilteredQuery(resultData) {
    const table = resultData && resultData.tables && resultData.tables[0];
    const column = table && table.columns && table.columns[0];
    return column;
}
function getRowDataForTable(node, resultData) {
    return (0, VirtualConnectionRowDataFunctions_1.getRowDataWithMaxCountsForVirtualConnection)(node, selectMaxCountsResult(resultData));
}
function getRowDataForTableForFilteredQuery(node, resultData) {
    return (0, VirtualConnectionRowDataFunctions_1.getRowDataWithMaxCountsForVirtualConnection)(node, selectMaxCountsResultForFilteredQuery(resultData));
}
function TableDownstreamVirtualConnectionsQueryGrid(props) {
    const emptyGridMessage = catalog_messages_1.Messages.EmptyDownstreamVirtualConnectionsLineageGridMessage();
    const emptyFilteredGridMessage = catalog_messages_1.Messages.EmptyDownstreamFilteredTablesLineageGridMessage();
    return props.filteredColumnId
        ? (react_1.default.createElement(data_catalog_shared_1.PaginatedQueryWrapper, { queryGql: catalog_queries_1.TableDownstreamVirtualConnectionsFilteredByColumnDocument, partialQueryVariables: {
                tableId: props.tableId,
                columnId: props.filteredColumnId,
                orderBy: props.orderBy,
            }, selectConnectionListResult: selectConnectionListResultForFilteredQuery, mapResultNode: getRowDataForTableForFilteredQuery }, ({ rowStore }) => (react_1.default.createElement(VirtualConnectionsDisplayGrid_1.VirtualConnectionsDisplayGrid, { rowStore: rowStore, emptyGridMessage: emptyFilteredGridMessage, rowCount: props.rowCount, orderBy: props.orderBy, updateSortOrder: props.updateSortOrder }))))
        : (react_1.default.createElement(data_catalog_shared_1.PaginatedQueryWrapper, { queryGql: catalog_queries_1.TableDownstreamVirtualConnectionsDocument, partialQueryVariables: {
                tableId: props.tableId,
                orderBy: props.orderBy,
            }, selectConnectionListResult: selectConnectionListResult, mapResultNode: getRowDataForTable }, ({ rowStore }) => (react_1.default.createElement(VirtualConnectionsDisplayGrid_1.VirtualConnectionsDisplayGrid, { rowStore: rowStore, emptyGridMessage: emptyGridMessage, rowCount: props.rowCount, orderBy: props.orderBy, updateSortOrder: props.updateSortOrder }))));
}
exports.TableDownstreamVirtualConnectionsQueryGrid = TableDownstreamVirtualConnectionsQueryGrid;
//# sourceMappingURL=TableDownstreamVirtualConnectionsQueryGrid.js.map